import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import * as MessagesActions from './messages.actions';
import { MessageType } from "@hub-services/interfaces/message-type.enum";
import { ApiErrorService } from '@hub-services/index';


@Injectable()
export class MessagesEffects {

  createMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MessagesActions.createMessages),
      switchMap(action => {
        if (!action.messages?.length) {
          return of(MessagesActions.createDefaultMessage())
        }

        let actions = [];

        for (const message of action.messages) {
          actions.push(MessagesActions.createMessage({
            message: {
              type: action.messageType,
              text: message,
              ...(action.referenceId ? { referenceId: action.referenceId } : {}),
            }
          }));
        }

        return from(actions);
      })
    );
  });

  createExtendedErrorMessage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MessagesActions.createExtendedErrorMessage),
      switchMap(action => {
        const messages = this.apiErrorService.getMessages(action.error);
        const referenceId = this.apiErrorService.getReferenceId(action.error);
        const allMessages = [
          ...messages,
          ...(action.extraMessage ? [action.extraMessage] : [])
        ];
        const alertMessage = allMessages.length ? allMessages.join(', ') : this.apiErrorService.getMessage(action.error);

        return of(MessagesActions.createMessages({
          messageType: MessageType.ALERT,
          messages: [alertMessage],
          ...(referenceId !== '' ? { referenceId: referenceId } : {})
        }));

      }),
    );
  });

  constructor(
    private actions$: Actions,
    private apiErrorService: ApiErrorService,
  ) { }

}
